"use client";

import { useLocale } from "next-intl";
import { useRouter, usePathname } from "next/navigation";
import { useCallback } from "react";

export const LangueSwitcher = () => {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const toggleLocale = useCallback(() => {
    const newLocale = locale === "fr" ? "en" : "fr";
    const pathWithoutLocale = pathname.replace(`/${locale}`, "");
    const newPath = `/${newLocale}${pathWithoutLocale}`;
    router.replace(newPath);
  }, [locale, router, pathname]);

  return (
    <button
      onClick={toggleLocale}
      className="text-accent transition-colors duration-300 hover:text-secondary"
    >
      {locale.toUpperCase()}
    </button>
  );
};
